/**
 * Catch-all 404 (T9) — registered as the `*` route in App.tsx, last in
 * the route list so it only matches paths nothing else claimed.
 */

import { Card, EmptyState, Layout, Page } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';
import { EMPTY_STATE_IMAGE } from '../config/emptyState';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Page title="Page not found">
      <Layout>
        <Layout.Section>
          <Card>
            <EmptyState
              heading="We couldn't find that page"
              image={EMPTY_STATE_IMAGE}
              action={{ content: 'Go home', onAction: () => navigate('/') }}
            >
              <p>The page you&apos;re looking for doesn&apos;t exist or has moved.</p>
            </EmptyState>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
